<template>
  <WdsTooltip :global="tableGlobals">
    <WdsLabel primary sm subtle>#{{ column.number }}</WdsLabel>
    <template #tooltip-content>
      <strong>{{ $t('Contract timeframe') }}</strong>
      <br />
      {{ formatDate(column.startDate) }} - {{ formatDate(column.endDate) }}
    </template>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import moment from 'moment'
import { WdsLabel, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const RecruiterPlacementContractColumn = graphql(`
  fragment RecruiterPlacementContractColumn on Hire {
    id
    number
    startDate
    endDate
    recruiterOwnershipStartDate
    recruiterManagesWorkers
    latestContract {
      id
      status
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof RecruiterPlacementContractColumn> }>()
const column = computed(() => useFragment(RecruiterPlacementContractColumn, props.row))

const formatDate = (date: string | null | undefined) =>
  date ? moment(date).format('YYYY-MM-DD') : '?'
</script>
